import { usePermissions } from '@melio/platform-permissions';

export const useCollaboratorsPermissions = () => {
  const { can } = usePermissions();

  const canInviteCollaborator = can({ action: 'create', subject: 'invitation' });
  const canEditCollaborator = can({ action: 'update', subject: 'collaborator' });

  return { canInviteCollaborator, canEditCollaborator };
};
